import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

import auth from './auth';
import dashboard from './dashboard';
import conversions from './conversions';
import postbacks from './postbacks';
import table from './table';
import mainData from './main-data';
import tutorial from './tutorial';
import report from '@/store/report';
import billing from '@/store/billing';
import cache from '@/store/cache';
import customColumns from '@/store/customColumns';
import reportColumns from '@/store/reportColumns';
import mobile from '@/store/mobile';

const storeObject = {
  state: {
    ...mainData.state,
    ...auth.state,
    dashboard: dashboard.state,
    ...conversions.state,
    ...postbacks.state,
    table: table.state,
    tutorial: tutorial.state,
    ...billing.state,
    cache: cache.state,
    ...customColumns.state,
    report: report.state,
    mobile: mobile.state,
    reportColumns: reportColumns.state,

  },
  mutations: {
    ...mainData.mutations,
    ...auth.mutations,
    ...dashboard.mutations,
    ...conversions.mutations,
    ...postbacks.mutations,
    ...table.mutations,
    ...tutorial.mutations,
    ...billing.mutations,
    ...cache.mutations,
    ...customColumns.mutations,
    ...report.mutations,
    ...reportColumns.mutations,
    ...mobile.mutations,
  },
  actions: {
    ...reportColumns.actions,
    ...table.actions
  },
  getters: {
    ...mainData.getters,
    ...auth.getters,
    ...customColumns.getters,
    ...table.getters,
    ...report.getters,
    ...reportColumns.getters,
    ...billing.getters,
    ...cache.getters,
  }
};

const store = new Vuex.Store(storeObject);

export default store;
